module.exports = __webpack_public_path__ + "img/smsModal.4486686a.png";